import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from '@progress/kendo-angular-grid';
// import { SharedModule } from '../../../shared/shared.module';

import { EmailSendToIntacctComponent } from './email-send-to-intacct.component';

@NgModule({
  declarations: [EmailSendToIntacctComponent],
  imports: [
    CommonModule,
    GridModule,
    //SharedModule,
  ],
  exports: [EmailSendToIntacctComponent], 
  providers: [ ],
})
export class EmailSendToIntacctModule { }